var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showButtonConfirm)?_c('confirmar-consulta-btn',{attrs:{"modelo":_vm.modelo,"confirmed":_vm.confirmed,"confirmar-consulta":_vm.confirmarPresenca}}):_vm._e(),(_vm.showButtonCancel)?_c('cancelar-consulta-btn',{attrs:{"modelo":_vm.modelo,"cancelar-consulta":_vm.cancelar}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }